import React, { Component } from 'react';

import 'css/components/widget/_WidgetLoading.scss';

export default class WidgetLoading extends Component {
  render() {
    return <div className="widgetLoading" />;
  }
}
